import * as React from 'react';
import { Callout } from '@fluentui/react';
import { Persona, IPersonaSharedProps, PersonaSize, Icon } from '@fluentui/react';
import { UserContact, UserManager } from '../../Models/UserProfile';
import '../Components/UserCard.css';
import { UATConstants } from 'src/Common/Models/UATConstants';
export interface UserCardProps {
  userContactDetails: UserContact;
  userManagerDetails: UserManager;
  setButtonId: Function;
}

export interface UserCardState {
  buttonId: string;
  toggleIsCalloutVisible: boolean;
  isCalloutVisible: boolean;
  userContactDetails: UserContact;
  userManager: UserManager;
}

export default class UserCard extends React.Component<UserCardProps, UserCardState> {
  constructor(props: UserCardProps, state: UserCardState) {
    super(props, state);
    this.state = {
      userContactDetails: new UserContact(),
      userManager: new UserManager(),
      isCalloutVisible: true,
      toggleIsCalloutVisible: true,
      buttonId: 'callout-button',
    };
  }

  userObject = this.props.userContactDetails;
  userPersona: IPersonaSharedProps = {
    text: this.userObject.displayName,
    secondaryText: this.userObject.jobTitle,
  };
  managerObj = this.props.userManagerDetails;
  managerPersona: IPersonaSharedProps = {
    text: this.managerObj.displayName,
    secondaryText: this.managerObj.jobTitle,
  };

  render() {
    return (
      <div>
        {this.state.isCalloutVisible && (
          <Callout
            gapSpace={0}
            target={`#${this.state.buttonId}`}
            onDismiss={() => {
              this.setState({
                toggleIsCalloutVisible: false,
                isCalloutVisible: false,
                buttonId: '',
              });
              this.props.setButtonId();
            }}
            setInitialFocus>
            <div className='cardStyle'>
              <div>
                <Persona
                  {...this.userPersona}
                  imageUrl={this.props.userContactDetails.displayPicture}
                  size={PersonaSize.size72}
                  text={this.props.userContactDetails.displayName}
                  secondaryText={this.props.userContactDetails.jobTitle}
                  tertiaryText={this.props.userContactDetails.department}
                  styles={{
                    secondaryText: { fontSize: '12px' },
                    tertiaryText: { fontSize: '12px' },
                  }}
                />
              </div>
              <hr></hr>
              <div className='Contacts'>
                {' '}
                Contact <span className='personaIcon'></span>
                <div>
                  <span className='personaIcon'>
                    <Icon iconName={UATConstants.PlaceholdersAndTitles.Mail} />
                  </span>{' '}
                  <a href={'mailto:' + this.props.userContactDetails.email} className='mailColor'>
                    {this.props.userContactDetails.email}
                  </a>
                </div>
                {this.props.userContactDetails.email && (
                  <div>
                    <span className='personaIcon'>
                      <Icon iconName={UATConstants.PlaceholdersAndTitles.Chat} />
                    </span>{' '}
                    <a href={'sip:' + this.props.userContactDetails.email} className='mailColor'>
                      {UATConstants.PlaceholdersAndTitles.StartChat}
                    </a>{' '}
                  </div>
                )}
                {this.props.userContactDetails.businessPhone && (
                  <div>
                    <span className='personaIcon'>
                      <Icon iconName={UATConstants.PlaceholdersAndTitles.Phone} />
                    </span>{' '}
                    {this.props.userContactDetails.businessPhone}
                  </div>
                )}
                {this.props.userContactDetails.officeLocation && (
                  <div>
                    <span className='personaIcon'>
                      <Icon iconName={UATConstants.PlaceholdersAndTitles.Location} />
                    </span>{' '}
                    {this.props.userContactDetails.officeLocation}
                  </div>
                )}
              </div>
              {this.props.userManagerDetails.displayName && (
                <div>
                  <hr className='hrLine'></hr>
                  <div className='organization'>
                    <div className='reportsTo'>
                      <span></span>
                      {UATConstants.PlaceholdersAndTitles.ReportsTo}
                    </div>
                    <div>
                      <Persona
                        {...this.managerPersona}
                        imageUrl={this.props.userManagerDetails.displayPicture}
                        size={PersonaSize.size48}
                        text={this.props.userManagerDetails.displayName}
                        secondaryText={this.props.userManagerDetails.jobTitle}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Callout>
        )}
      </div>
    );
  }
}
